import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import EventsPage from './pages/EventsPage';
import UsersPage from './pages/UsersPage';
import StationsPage from './pages/StationsPage';
import QuestionsPage from './pages/QuestionsPage';
import AgendasPage from './pages/AgendasPage';
import TopicsPage from './pages/TopicsPage';
import SpeakersPage from './pages/SpeakersPage';
import PromotionsPage from './pages/PromotionsPage';
import SurveysPage from './pages/SurveysPage';
import DesignStudioPage from './pages/DesignStudioPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/events" replace />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="stations" element={<StationsPage />} />
            <Route path="questions" element={<QuestionsPage />} />
            <Route path="agendas" element={<AgendasPage />} />
            <Route path="topics" element={<TopicsPage />} />
            <Route path="speakers" element={<SpeakersPage />} />
            <Route path="promotions" element={<PromotionsPage />} />
            <Route path="surveys" element={<SurveysPage />} />
            <Route path="design" element={<DesignStudioPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
